module.exports = __webpack_public_path__ + "img/logo.32fffd1e.png";